'use client';

import { MantineProvider as MantineProviderComponent } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';

const MantineProvider = ({ children }) => {
  return (
    <MantineProviderComponent>
      <ModalsProvider>{children}</ModalsProvider>
    </MantineProviderComponent>
  );
};

export { MantineProvider };
